// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"d4e27675","462":"ed7218b2","735":"7ea4ff8d","841":"7441b222","880":"c8dfae08","883":"8862f741","887":"8862f741"}[chunkId] + ".chunk.css";
};